import React, { useEffect, useState } from 'react'
import { useApiStore } from '../../hooks/ApiStoreContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import dateFormat from "dateformat";
import "./ViewOrder.css";

function ViewOrder() {
    const apiStore = useApiStore();
    const navigate = useNavigate();
    const location = useLocation();
    const [orderStatusList, setOrderStatusList] = useState([]);
    const [paymentStatusList, setPaymentStatusList] = useState([]);
    const [orderDetail, setOrderDetail] = useState({});
    const [userDetail, setUserDetail] = useState({});
    const [addressDetail, setAddressDetail] = useState({});
    const [billingAddressDetail, setBillingAddressDetail] = useState({});
    const [productDetail, setProductDetail] = useState([]);
    const [productImageUrls, setProductImageUrls] = useState({});
    
    //const [orderStatus, setOrderStatus] = useState({});
    //const [paymentStatus, setPaymentStatus] = useState({});

    // useEffect(() => {
    //     // Fetch order status
    //     getOrderStatus();
    //     getPaymentStatus();
    // }, []);

    useEffect(() => {
        let orderId = location.pathname.split("/")[2];
        getOrderStatus();
        getPaymentStatus();
        fetchOrderDetails(orderId);
        //console.log(orderStatusList);

    }, [location]);

    // Fetch image URLs when productDetail changes
    let imageUrls = {};
    useEffect(() => {
        const fetchImages = async () => {
            for (const pd of productDetail) {
                if (pd.product?.productImages?.[0]?.productImageId) {
                try {
                    const imageUrl = await renderImage(pd.product.productImages[0].productImageId);
                    imageUrls[pd.orderItemId] = imageUrl;
                } catch (error) {
                    console.error(`Error fetching image for product ${pd.orderItemId}:`, error);
                }
                }
            }
            setProductImageUrls(imageUrls);
        };

        if (productDetail.length > 0) {
            fetchImages();
        }

        // Cleanup blob URLs to prevent memory leaks
        return () => {
            Object.values(imageUrls).forEach((url) => {
                if (url.startsWith('blob:')) {
                URL.revokeObjectURL(url);
                }
            });
        };
    }, [productDetail]);

    const fetchOrderDetails = async (orderId) => {
        try {
            const response = await apiStore.get(`/order/${orderId}`);
            console.log(response);
            setOrderDetail(response);
            setUserDetail(response.user);
            setAddressDetail(response.deliveryAddress);
            setBillingAddressDetail(response.billingAddress);
            setProductDetail(response.orderItems);

        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching the product!", error);
            }
        }
    };

    const getOrderStatus = async () => {
        try {
            const response = await apiStore.get("/Order/GetOrderStatusList");
            //console.log(response);      
            setOrderStatusList(response);
        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching order status!", error);
            }
        }
    };

    const getPaymentStatus = async () => {
        try {
            const response = await apiStore.get("/Order/GetPaymentStatusList");
            //console.log(response);
            setPaymentStatusList(response);
        } catch (error) {
            if (error.response.status !== 401) {
                console.error("There was an error fetching payment status!", error);
            }
        }
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate("/order");
    };

    const renderOrderStatus = (statusId) => {
        let statusName = orderStatusList.find(obj => obj.id === statusId)
        //console.log(statusName); // Log the message
        return <span>{statusName !== undefined ? statusName.name : ''}</span>;
    };

    const renderPaymentStatus = (paymentId) => {
        let paymentName = paymentStatusList.find(obj => obj.id === paymentId)
        //console.log(paymentName); // Log the message
        return <span>{paymentName !== undefined ? paymentName.name : ''}</span>;
    };

    const renderImage = async (imageId) => {
        console.log(imageId); // Log the imageId
        try {
            const imageBlob = await apiStore.getBlob(`/product/getImage/${imageId}`);
            const imagePath = URL.createObjectURL(imageBlob);
            console.log(imagePath); // Log the blob URL
            return imagePath;
        } catch (error) {
            console.error('Error fetching image:', error);
        }
    };


    return (
        <Row>
            <Col md={12}>
                <Card className="mb-4">
                    <CardHeader className="pb-0">
                        <Row>
                            <Col md={9}>
                                <h4>Order Details</h4>
                            </Col>
                            <Col md={3} className="d-grid d-md-flex justify-content-md-end d-sm-block">
                                <Button variant="outline-primary" className="btn-sm" onClick={handleBack}>
                                    Back
                                </Button>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="px-0 pt-0 pb-2">

                        <Row className="mb-3" style={{ padding: "0 20px" }}>
                            <Col md={12} className="border-0 p-4 bg-gray-100 border-radius-lg">
                                <h5 className='mb-2'>User Details</h5>
                                <Row>
                                    <Col md={3}>Order Id :</Col>
                                    <Col md={9} className="text-dark font-weight-bold ">{orderDetail.orderId}</Col>
                                    <Col md={3}>Company Name :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{userDetail.firstName}</Col>
                                    <Col md={3}>Contact Person :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{userDetail.lastName}</Col>
                                    <Col md={3}>Email Id :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{userDetail.email}</Col>
                                    <Col md={3}>Contact No :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{userDetail.contact}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mb-3" style={{ padding: "0 20px" }}>
                            <Col md={12} className="border-0 p-4 bg-gray-100 border-radius-lg">
                                <h5 className='mb-2'>Delivery Address</h5>
                                <Row>
                                    <Col md={3}>Contact Person :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.contactPerson}</Col>
                                    <Col md={3}>GST No. :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.gstNumber}</Col>
                                    <Col md={3}>Address Line 1 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.addressLine1}</Col>
                                    <Col md={3}>Address Line 2 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.addressLine2}</Col>
                                    <Col md={3}>Address Line 3 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.addressLine3}</Col>
                                    <Col md={3}>City :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.city}</Col>
                                    <Col md={3}>State :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.state}</Col>
                                    <Col md={3}>Country :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.country}</Col>
                                    <Col md={3}>Zipcode :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.zipCode}</Col>
                                    <Col md={3}>Transport :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{addressDetail.transport}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mb-3" style={{ padding: "0 20px" }}>
                            <Col md={12} className="border-0 p-4 bg-gray-100 border-radius-lg">
                                <h5 className='mb-2'>Billing Address</h5>
                                <Row>
                                    <Col md={3}>Contact Person :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.contactPerson}</Col>
                                    <Col md={3}>GST No. :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.gstNumber}</Col>
                                    <Col md={3}>Address Line 1 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.addressLine1}</Col>
                                    <Col md={3}>Address Line 2 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.addressLine2}</Col>
                                    <Col md={3}>Address Line 3 :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.addressLine3}</Col>
                                    <Col md={3}>City :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.city}</Col>
                                    <Col md={3}>State :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.state}</Col>
                                    <Col md={3}>Country :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.country}</Col>
                                    <Col md={3}>Zipcode :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.zipCode}</Col>
                                    <Col md={3}>Transport :</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{billingAddressDetail.transport}</Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="mb-3" style={{ padding: "0 20px" }}>
                            <Col md={12} className="border-0 p-4 bg-gray-100 border-radius-lg">
                                <h5 className='mb-2'>Product Details</h5>
                                {
                                    productDetail.map((pd) => (
                                        <Row key={pd.orderItemId} className='border-0 p-4 mb-3 bg-white border-radius-lg'>
                                            <Col md={3}>Product Name :</Col>
                                            <Col md={3} className="text-dark font-weight-bold ">{pd.product.name}</Col>
                                            <Col md={3}>Product Code :</Col>
                                            <Col md={3} className="text-dark font-weight-bold ">{pd.product.code}</Col>
                                            <Col md={3}>Quantity :</Col>
                                            <Col md={3} className="text-dark font-weight-bold ">{pd.quantity}</Col>
                                            <Col md={3}>HSN Code :</Col>
                                            <Col md={3} className="text-dark font-weight-bold ">{pd.product.hsnCode}</Col>
                                            <Col md={3}>Image :</Col>
                                            <Col md={3} className="text-dark font-weight-bold ">
                                                <figure className="img-product">
                                                    <img src={productImageUrls[pd.orderItemId]} alt="product" />
                                                </figure>
                                            </Col>
                                        </Row>
                                    ))
                                }
                            </Col>
                        </Row>
                        <Row className="mb-3" style={{ padding: "0 20px" }}>
                            <Col md={12} className="border-0 p-4 bg-gray-100 border-radius-lg">
                                <h5 className='mb-2'>Payment Details</h5>
                                <Row>
                                    <Col md={3}>Order Date:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{dateFormat(orderDetail.orderdate, "dd/mm/yyyy")}</Col>
                                </Row>
                                <Row>
                                    <Col md={3}>Sub Total Amount:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{orderDetail.subTotal}</Col>
                                </Row>
                                <Row>
                                    <Col md={3}>Discount:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{orderDetail.subTotal - (orderDetail.totalAmount - orderDetail.gstAmount)}</Col>
                                    </Row>
                                <Row>
                                    <Col md={3}>GST:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{orderDetail.gstAmount}</Col>
                                    </Row>
                                <Row>
                                    <Col md={3}>Total Amount:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{orderDetail.totalAmount}</Col>
                                    </Row>
                                <Row>
                                    <Col md={3}>Order Status:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{renderOrderStatus(orderDetail.orderStatus)}</Col>
                                    </Row>
                                <Row>
                                    <Col md={3}>Payment Status:</Col>
                                    <Col md={3} className="text-dark font-weight-bold ">{renderPaymentStatus(orderDetail.paymentStatus)}</Col>
                                </Row>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default ViewOrder